import React from 'react';
import '../../../css/page/placeholder-component.less';

class PlaceholderComponent extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div className="placeholder-component component-wrapper editing">
                <div className="placeholder-child"><span>New Component</span></div>
                <div className="placeholder-child"></div>
            </div>
        );

    }

}

export default PlaceholderComponent;
